<template>
    <el-dialog
      title="用户评价"
      :visible.sync="status"
      width="800px"
      :close-on-click-modal="false"
     
      :before-close="esc">
      <div class="comment-form">
        <div class="cont-row">
            <div class="user-avator"><YorkbbsImage borderRadius="50%" width="30px" height="30px" :src="loginUser.avatar" animation></YorkbbsImage></div>
            <div class="flex-cont">
                <div class="content-input mrg-btm20"><el-input v-model="params.content" placeholder="大家都在问：菜品口味如何，服务态度好吗，环境（空间、布置）怎么样？" type="textarea" :rows="6" resize="none"></el-input></div>
              
                
              
                
                <div class="item-row mrg-btm30">
                   
                    <el-button @click="esc" size="small">取消</el-button>
                    <el-button type="primary" @click="ensure" size="small" :loading="postLoading">提交</el-button>
                </div>
            </div>
        </div>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="esc">取 消</el-button>
        <el-button type="primary" @click="ensure">确 定</el-button>
      </span> -->
    </el-dialog>
    </template>
    <script>
    import SelectCommentScore from './comment-score.vue'
    import FormUploadButton from '@/common/form-upload/form-upload-button.vue'
    import OnlyUpload from '@/common/only-uploadImg.vue'

    export default {
        name:'DialogCommentReply',
        props:['post','status','parentCommentId'],
        components:{
            SelectCommentScore,
            FormUploadButton,
            OnlyUpload,
        },
        computed:{
            loginUser(){
                return this.$store.getters.user;
            }
        },
        data(){
            return {
                postLoading:false,
                showViewProgess:false,
                videoErr:false,
                videoBuffer:'',
                money:'',
                params:{
                    "postId": "",
                    // ****  parentCommentId  ****
                    // 在对信息主体评论时传空字符串 ""
                    // 对评论进行评论时传目标评论的id
                    "parentCommentId": 0, 
                    "stars": 0, // 评分
                    "price": 0, // 人均价格，单位是CAD
                    "content": "",
                    "imageList": [
                        /* 'https://media5.imgyb.xyz/media/v1/image/d701516ecec2e0057fb4288689a02cec.jpeg',
                        'https://media3.imgyb.xyz/media/v1/image/3ab96be88b4925fd4204f8f376aa3ed7.jpeg', */
                    ],
                    "videoList": [], // 没有则传空数组
                    "dishIdList": [] // 推荐菜id列表，没有则传空数组
                },
                dishList:[],
                selectDish:null,
            }
        },
        methods:{
       
            esc(){
                if( this.postLoading ) return false;
                this.$emit('update:status',false)
                this.params.content='';
                this.params.stars = 0;
                this.params.imageList = [];
                this.params.dishIdList=[];
                this.price = '';
    
            },
            async ensure(){
                if( this.postLoading ) return false;
                if( this.params.content.length == 0 ) return this.$warning('请留下您珍贵的意见');
                let sendData = {...this.params};
                sendData.postId = this.post.id;
               
                sendData.parentCommentId = this.parentCommentId;
            
                this.postLoading = true;
                let result = await this.$axios.post('/comment/frontend/v1/create/comment',sendData)
                this.postLoading = false;
             
                if( result.code == 0 ){
                    this.$success('评论成功');
                    this.esc();
                    this.$emit('success');
                }
            },
            
          
          
            
        }
    }
    </script>
    <style lang="scss" scoped>
    .mrg-btm20{margin-bottom: 20px;}
    .mrg-btm30{margin-bottom: 30px;}
    .comment-form{
        .cont-row{
            display: flex;
            .user-avator{
                margin-right: 20px;
            }
            .flex-cont{flex:1;overflow: hidden;}
        }
      
        .item-row{
            display: flex;
            .lab{width:75px; line-height: 32px; color: #222; font-size: 16px;}
        }
       
        
    }
    

    </style>